import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { modificarTramite, cancelarTramite, reactivarTramite } from "../../services/tramiteService";
import { getTramiteARTById, getTramitesSimilares, getEvaluacionArtCliente, actualizarTramiteART } from "../../services/art/tramiteARTService";
import { getTramites } from "../../services/tramiteService";
import { getAseguradoras } from "../../services/art/aseguradoraService";
import { getSiniestrosPorTramite } from "../../services/art/siniestroService";
import EventoService from '../../services/eventoService';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import CrearEventoModal from '../../components/CrearEventoModal';
import ChecklistTramite from '../../components/Tramite/ChecklistTramite';
import TarjetaCobroTramite from '../../components/Cobranzas/TarjetaCobroTramite';
import SeccionCobranzaTramite from '../../components/Cobranzas/SeccionCobranzaTramite';
import useCustomModal from "../../hooks/useCustomModal";
import useVolverAtras from "../../hooks/useVolverAtras";
import CustomModal from "../../components/CustomModal";
import HistorialTramite from "../../components/HistorialTramite";
import PanelAccionesAvanzadasTramite from '../../components/Administracion/PanelAccionesAvanzadasTramite';
import CargaArchivos from "../../gestores/GestorCargaDeArchivos";
import BotonGenerarCaratula from '../../components/Caratula/BotonGenerarCaratula';
import ModalGastosPorTramite from '../../components/GastosMedicosComponentes/ModalGastosPorTramite';
import WhatsAppChatModal from '../../components/WhatsAppChatModal';
import WhatsAppHeaderButton from '../../components/WhatsAppHeaderButton';
import PanelUbicacionTramite from '../../components/PanelUbicacionTramite';
import NotaComentario from '../../components/NotaComentario';
import NotificacionService from "../../services/notificacionService";
import { useAuth } from '../../auth/AuthContext';
import ModalFormularioSiniestro from '../../components/ART/ModalFormularioSiniestro';
import ModalDetalleSiniestro from '../../components/ART/ModalDetalleSiniestro';
import ModalPreexistencias from '../../components/ART/ModalPreexistencias';
import { getPreexistencias } from "../../services/art/preexistenciaService";
import { Button, Box, Chip, Paper, Typography } from "@mui/material";
import GestorCambioEstadoART from "../../gestores/gestoresART/GestorCambioEstadoART";
import ListarSiniestros from '../../components/ART/ListarSiniestros';
import { normalizeTelefonoForStorage } from '../../utils/telefonoCordoba';
import FeedbackButton from '../../components/FeedbackButton';
import { apellidoNombre } from '../../utils/nombrePersona';
import EtiquetaTramite from '../../components/EtiquetaTramite';

const formatLocalFecha = (fechaInput) => {
    if (!fechaInput) return '';
    if (typeof fechaInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaInput)) {
        return fechaInput;
    }
    const d = new Date(fechaInput);
    if (Number.isNaN(d.getTime())) return '';
    return new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
};

function VistaDetalladaTramiteART() {
    const { idTramite } = useParams();
    const { user } = useAuth();
    const [tramite, setTramite] = useState(null);
    // Se bumpea despues de generar+adjuntar la Caratula para forzar el remount (y re-fetch)
    // de CargaArchivos, que no expone otra forma de refrescarse desde el padre.
    const [archivosVersion, setArchivosVersion] = useState(0);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const volverAtras = useVolverAtras('/art/tramites');
    const [editMode, setEditMode] = useState(false);
    const [tramiteEdit, setTramiteEdit] = useState(null);
    const [mostrarDialogoCancelar, setMostrarDialogoCancelar] = useState(false);
    const [motivoCancelacion, setMotivoCancelacion] = useState('');
    const [observacionesCancelacion, setObservacionesCancelacion] = useState('');
    const [mostrarDialogoReactivar, setMostrarDialogoReactivar] = useState(false);
    const [observacionesReactivacion, setObservacionesReactivacion] = useState('');
    const [eventos, setEventos] = useState([]);
    const [cargandoEventos, setCargandoEventos] = useState(true);
    const [mostrarModalEvento, setMostrarModalEvento] = useState(false);
    const [fechaSeleccionadaEvento, setFechaSeleccionadaEvento] = useState(new Date());
    const { modalState, hideModal, showModal, showError } = useCustomModal();
    const [modalHistorialAbierto, setModalHistorialAbierto] = useState(false);
    const [modalGastosOpen, setModalGastosOpen] = useState(false);
    // { phone, name } del contacto activo en el chat; null = cerrado
    const [whatsAppTarget, setWhatsAppTarget] = useState(null);
    const [modalPreexistenciasOpen, setModalPreexistenciasOpen] = useState(false);
    const [preexistenciasCliente, setPreexistenciasCliente] = useState([]);
    const [tramitesSimilares, setTramitesSimilares] = useState([]);
    const [tramitesRTICliente, setTramitesRTICliente] = useState([]);
    const [evaluacionArt, setEvaluacionArt] = useState(null);
    const [aseguradoras, setAseguradoras] = useState([]);

    // --- Siniestros ---
    const [siniestros, setSiniestros] = useState([]);
    const [cargandoSiniestros, setCargandoSiniestros] = useState(false);
    const [modalFormSiniestroOpen, setModalFormSiniestroOpen] = useState(false);
    const [modalDetalleSiniestroOpen, setModalDetalleSiniestroOpen] = useState(false);
    const [siniestroSeleccionado, setSiniestroSeleccionado] = useState(null);
    const [siniestroAEditar, setSiniestroAEditar] = useState(null);

    // Pestaña activa para la sección inferior

    const recargarEventos = async () => {
        try {
            const response = await EventoService.getEventosPorTramite(idTramite);
            setEventos(response.data);
        } catch (error) {
            console.error("Error recargando eventos:", error);
        }
    };

    const recargarTramite = async () => {
        try {
            const dataTramite = await getTramiteARTById(idTramite);
            setTramite(dataTramite);
            if (dataTramite?.cliente?.cuil) {
                try {
                    const evaluacion = await getEvaluacionArtCliente(dataTramite.cliente.cuil);
                    setEvaluacionArt(evaluacion);
                } catch (error) {
                    console.error("Error recargando evaluación ART:", error);
                    setEvaluacionArt(null);
                }
            }
        } catch (error) {
            console.error("Error recargando trámite:", error);
        }
    };

    const cargarSiniestros = async () => {
        setCargandoSiniestros(true);
        try {
            const data = await getSiniestrosPorTramite(idTramite);
            setSiniestros(data || []);
        } catch (error) {
            console.error("Error cargando siniestros:", error);
            setSiniestros([]);
        } finally {
            setCargandoSiniestros(false);
        }
    };

    const handleVerTramiteSimilar = (idTramiteSimilar) => {
        setLoading(true);
        setTramite(null);
        navigate(`/art/tramites/${idTramiteSimilar}`);
    };

    const cargarPreexistenciasCliente = async (cuilParam = null) => {
        const cuil = cuilParam || tramite?.cliente?.cuil;
        if (!cuil) return;
        try {
            const data = await getPreexistencias(cuil);
            setPreexistenciasCliente(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error cargando preexistencias:", error);
            setPreexistenciasCliente([]);
        }
    };

    useEffect(() => {
        const cargarDatos = async () => {
            try {
                setLoading(true);
                setCargandoEventos(true);
                setCargandoSiniestros(true);


                const [tramiteResult, eventosResult, siniestrosResult, similaresResult] = await Promise.allSettled([
                    getTramiteARTById(idTramite),
                    EventoService.getEventosPorTramite(idTramite),
                    getSiniestrosPorTramite(idTramite),
                    getTramitesSimilares(idTramite),
                ]);

                const dataTramite = tramiteResult.status === 'fulfilled' ? tramiteResult.value : null;
                setTramite(dataTramite);
                setEventos(eventosResult.status === 'fulfilled' ? eventosResult.value.data : []);
                setSiniestros(siniestrosResult.status === 'fulfilled' ? (siniestrosResult.value || []) : []);
                setTramitesSimilares(similaresResult.status === 'fulfilled' && Array.isArray(similaresResult.value) ? similaresResult.value : []);

                if (tramiteResult.status !== 'fulfilled') {
                    console.error("Error cargando trámite:", tramiteResult.reason);
                    return;
                }

                if (dataTramite?.cliente?.cuil) {
                    const cuil = dataTramite.cliente.cuil;
                    const [preexistenciasResult, evaluacionResult, rtiResult] = await Promise.allSettled([
                        getPreexistencias(cuil),
                        getEvaluacionArtCliente(cuil),
                        getTramites(0, 50, cuil, 1, null, ''),
                    ]);

                    setPreexistenciasCliente(preexistenciasResult.status === 'fulfilled' && Array.isArray(preexistenciasResult.value) ? preexistenciasResult.value : []);
                    setEvaluacionArt(evaluacionResult.status === 'fulfilled' ? evaluacionResult.value : null);
                    const rtiData = rtiResult.status === 'fulfilled' ? rtiResult.value : null;
                    setTramitesRTICliente(Array.isArray(rtiData) ? rtiData : (rtiData?.content || []));
                }
            } catch (error) {
                console.error("Error al cargar trámite:", error);
            } finally {
                setLoading(false);
                setCargandoEventos(false);
                setCargandoSiniestros(false);
            }
        };
        cargarDatos();
    }, [idTramite]);

    useEffect(() => {
        const cargarAseguradoras = async () => {
            try {
                const data = await getAseguradoras(true);
                setAseguradoras(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Error cargando aseguradoras:", error);
                setAseguradoras([]);
            }
        };
        cargarAseguradoras();
    }, []);

    // Auto-refresco de eventos
    useEffect(() => {
        const handleEventoCreado = () => recargarEventos();
        window.addEventListener('eventoCreadoDesdeChat', handleEventoCreado);
        const interval = setInterval(() => recargarEventos(), 30000);
        return () => {
            window.removeEventListener('eventoCreadoDesdeChat', handleEventoCreado);
            clearInterval(interval);
        };
    }, [idTramite]);

    const handleModificar = () => {
        setTramiteEdit({
            ...tramite,
            idAseguradora: tramite?.idAseguradora || tramite?.artReclamo?.idAseguradora || '',
            clasificacion: tramite?.clasificacion || '',
            organismo: tramite?.organismo || ''
        });
        setEditMode(true);
    };

    const handleAbrirHistorial = () => setModalHistorialAbierto(true);
    const handleAbrirGastos = () => setModalGastosOpen(true);
    const handleCerrarGastos = () => setModalGastosOpen(false);

    const handleGuardar = async () => {
        try {
            const tramiteParaGuardar = {
                idTipoTramite: Number(tramiteEdit.idTipoTramite),
                comentarios: tramiteEdit.comentarios || "",
                idAseguradora: tramiteEdit.idAseguradora || tramiteEdit.artReclamo?.idAseguradora || null,
                fechaBaja: tramiteEdit.fechaBaja || null,
                fechaInicio: tramiteEdit.fechaInicio || null,
                clasificacion: tramiteEdit.clasificacion || null,
                organismo: tramiteEdit.organismo || null,
                version: tramite.version
            };
            const tramiteActualizado = await actualizarTramiteART(tramiteEdit.idTramite, tramiteParaGuardar);
            setTramite(tramiteActualizado);
            setEditMode(false);
            setTramiteEdit(null);
            toast.success("Trámite modificado correctamente");
        } catch (error) {
            console.error("❌ Error:", error.response?.data);
            if (error.response && error.response.status === 409) {
                showModal({
                    title: "⚠️ Conflicto de Edición",
                    body: (
                        <div className="alert alert-warning">
                            <p><strong>¡Atención!</strong></p>
                            <p>Otro usuario ha modificado este trámite mientras usted lo estaba editando.</p>
                            <p>Para evitar sobrescribir datos importantes, es necesario recargar la información más reciente.</p>
                            <hr/>
                            <p className="mb-0 text-muted" style={{fontSize: '0.9em'}}>
                                <em>Sus cambios actuales no se guardarán.</em>
                            </p>
                        </div>
                    ),
                    footer: (
                        <button className="btn btn-primary" onClick={() => { hideModal(); setEditMode(false); recargarTramite(); }}>
                            Entendido, recargar datos
                        </button>
                    )
                });
            } else {
                toast.error(`Error al guardar: ${error.response?.data?.message || error.message}`);
            }
        }
    };

    const handleGuardarComentario = async (nuevoComentario) => {
        try {
            const tramiteParaGuardar = {
                idTipoTramite: Number(tramite.tipoTramite?.idTipoTramite || tramite.idTipoTramite),
                comentarios: nuevoComentario,
                version: tramite.version
            };
            await modificarTramite(tramite.idTramite, tramiteParaGuardar);
            await recargarTramite();
            toast.success("Comentario actualizado correctamente");
        } catch (error) {
            console.error("Error al guardar comentario:", error);
            if (error.response && error.response.status === 409) {
                showModal({
                    title: "⚠️ Conflicto de Edición",
                    body: (
                        <div className="alert alert-warning">
                            <p><strong>¡Atención!</strong></p>
                            <p>Otro usuario ha modificado este trámite. Recargue la información.</p>
                        </div>
                    ),
                    footer: (
                        <button className="btn btn-primary" onClick={() => { hideModal(); recargarTramite(); }}>
                            Entendido, recargar datos
                        </button>
                    )
                });
            } else {
                toast.error(`Error al guardar comentario: ${error.response?.data?.message || error.message}`);
            }
            throw error;
        }
    };

    const handleGuardarEvento = async (evento) => {
        try {
            const responseEvento = await EventoService.crearEvento({
                ...evento,
                fecha: formatLocalFecha(evento.fecha),
                idTramite
            });
            const idEventoCreado = responseEvento.data.idEvento || responseEvento.data;
            if (evento.tiemposRecordatorio && evento.tiemposRecordatorio.length > 0) {
                await NotificacionService.programarNotificacionesAutomaticas(idEventoCreado, evento.tiemposRecordatorio);
            }
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { detail: { timestamp: Date.now(), source: 'tramite-art' } }));
            const response = await EventoService.getEventosPorTramite(idTramite);
            setEventos(response.data);
            setMostrarModalEvento(false);
            toast.success("Evento creado correctamente");
        } catch (error) {
            console.error("Error al crear evento:", error);
            toast.error("Error al crear el evento");
        }
    };

    const formatearFechaEvento = (fechaString) => {
        if (!fechaString) return 'Fecha no disponible';
        const partes = fechaString.split('-');
        const fechaUTC = new Date(Date.UTC(partes[0], partes[1] - 1, partes[2]));
        return fechaUTC.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
    };

    const formatearDuracionMeses = (meses) => {
        const total = Math.max(0, Number.isFinite(Number(meses)) ? Math.floor(Number(meses)) : 0);
        const anios = Math.floor(total / 12);
        const resto = total % 12;
        if (anios === 0) return `${resto} mes${resto === 1 ? '' : 'es'}`;
        if (resto === 0) return `${anios} año${anios === 1 ? '' : 's'}`;
        return `${anios} año${anios === 1 ? '' : 's'} y ${resto} mes${resto === 1 ? '' : 'es'}`;
    };

    const ESTADOS_POST_TELEGRAMA_DETALLE = new Set([
        'telegrama enviado', 'citación art', 'respuesta art',
        'iniciado en comisión médica', 'resolución srt', 'judicializado',
        'finalizado', 'cancelado',
    ]);

    const obtenerSemaforoArt = () => {
        const estadoNombre = (tramite?.nombreEstadoActual || '').toLowerCase().trim();
        if (ESTADOS_POST_TELEGRAMA_DETALLE.has(estadoNombre)) {
            return { borde: '#0891b2', badgeClass: 'badge-tramite-iniciado', badge: 'TRÁMITE INICIADO', estado: 'El telegrama fue enviado antes del vencimiento' };
        }
        if (tramite?.fechaVencimiento && typeof tramite.fechaVencimiento === 'string') {
            const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
            const venc = new Date(tramite.fechaVencimiento); venc.setHours(0, 0, 0, 0);
            if (isNaN(venc.getTime())) {
                return { borde: '#9ca3af', badgeClass: 'bg-secondary', badge: 'SIN DATOS', estado: 'Sin evaluación ART' };
            }
            const dias = Math.round((venc - hoy) / (1000 * 60 * 60 * 24));
            if (dias < 0)    return { borde: '#374151', badgeClass: 'bg-dark', badge: 'VENCIDO', estado: 'El plazo de 2 años ya venció' };
            if (dias <= 180) return { borde: '#d32f2f', badgeClass: 'bg-danger', badge: 'CRÍTICO', estado: 'Apto con plazo crítico' };
            if (dias <= 365) return { borde: '#ed6c02', badgeClass: 'bg-warning text-dark', badge: 'ATENCIÓN', estado: 'Apto con alerta de plazo' };
            return { borde: '#2e7d32', badgeClass: 'bg-success', badge: 'EN PLAZO', estado: 'Apto para inicio' };
        }
        const plazoRestante = Number(evaluacionArt?.plazoRestanteMeses);
        const puedeIniciar = Boolean(evaluacionArt?.art?.puedeIniciarTramite);
        if (!Number.isFinite(plazoRestante)) {
            return { borde: '#9ca3af', badgeClass: 'bg-secondary', badge: 'SIN DATOS', estado: 'Sin evaluación ART' };
        }
        if (!puedeIniciar || plazoRestante <= 0) {
            return { borde: '#374151', badgeClass: 'bg-dark', badge: 'VENCIDO', estado: 'No apto para inicio' };
        }
        if (plazoRestante <= 6) {
            return { borde: '#d32f2f', badgeClass: 'bg-danger', badge: 'CRÍTICO', estado: 'Apto con plazo crítico' };
        }
        if (plazoRestante <= 12) {
            return { borde: '#ed6c02', badgeClass: 'bg-warning text-dark', badge: 'ATENCIÓN', estado: 'Apto con alerta de plazo' };
        }
        return { borde: '#2e7d32', badgeClass: 'bg-success', badge: 'EN PLAZO', estado: 'Apto para inicio' };
    };

    const handleCancelar = () => { setEditMode(false); setTramiteEdit(null); };

    const handleCancelarTramite = async () => {
        try {
            await cancelarTramite(tramite.idTramite, motivoCancelacion, observacionesCancelacion);
            setMostrarDialogoCancelar(false);
            setMotivoCancelacion('');
            setObservacionesCancelacion('');
            const tramiteActualizado = await getTramiteARTById(idTramite);
            setTramite(tramiteActualizado);
            toast.success("Trámite cancelado correctamente");
        } catch (error) {
            console.error("❌ Error al cancelar trámite:", error);
            let mensaje;
            if (error.response) { mensaje = error.response.data || `Error ${error.response.status}: ${error.response.statusText}`; }
            else if (error.request) { mensaje = 'Error de conexión con el servidor'; }
            else { mensaje = error.message || 'Error desconocido'; }
            showError(mensaje, 'Error al Cancelar');
        }
    };

    const puedeCancelar = () => {
        if (!tramite) return false;
        return tramite.idEstadoActual !== 8 && tramite.idEstadoActual !== 14;
    };

    const handleReactivarTramite = async () => {
        try {
            await reactivarTramite(tramite.idTramite, observacionesReactivacion);
            setMostrarDialogoReactivar(false);
            setObservacionesReactivacion('');
            const tramiteActualizado = await getTramiteARTById(idTramite);
            setTramite(tramiteActualizado);
            toast.success("Trámite reactivado correctamente");
        } catch (error) {
            console.error("❌ Error al reactivar trámite:", error);
            let mensaje;
            if (error.response) { mensaje = error.response.data || `Error ${error.response.status}: ${error.response.statusText}`; }
            else if (error.request) { mensaje = 'Error de conexión con el servidor'; }
            else { mensaje = error.message || 'Error desconocido'; }
            showError(mensaje, 'Error al Reactivar');
        }
    };

    const puedeReactivar = () => {
        if (!tramite) return false;
        return tramite.idEstadoActual === 14;
    };

    // Ruta de estados específica para ART (simplificada)
    const obtenerRutaEstados = () => {
        // Ruta única alineada con el catálogo ART actualizado (V53)
        return [
            "Ingreso del trámite",
            "Turno médico asignado",
            "Espera de documentación",
            "Enviados a la médica",
            "Preparando telegrama",
            "Telegrama enviado",
            "Citación ART",
            "Respuesta ART",
            "Pendiente de Anexo",
            "Iniciado en comisión médica",
            "Resolución SRT",
            "Judicializado",
            "Finalizado",
        ];
    };

    const estadosOrden = obtenerRutaEstados();
    const estadosFallidosNombres = ["Cancelado"];

    // Banner de estado final
    const renderEstadoFinalBanner = () => {
        if (!tramite) return null;
        let config = null;
        const ultimoComentario = tramite.ultimoComentario || "Sin observaciones adicionales.";
        switch (tramite.idEstadoActual) {
            case 8:
                config = { bg: 'success', icon: <CheckCircleIcon style={{ fontSize: '2.5rem' }} />, titulo: 'Trámite ART Completo' };
                break;
            case 13:
                config = { bg: 'danger', icon: <CancelIcon style={{ fontSize: '2.5rem' }} />, titulo: 'Trámite ART Rechazado' };
                break;
            case 14:
                config = { bg: 'warning', icon: <WarningIcon style={{ fontSize: '2.5rem' }} />, titulo: 'Trámite ART Cancelado' };
                break;
            default:
                return null;
        }
        return (
            <div className={`alert alert-${config.bg} border-0 rounded-4 shadow-lg p-4 mb-4 d-flex align-items-center`}>
                <span className="me-3">{config.icon}</span>
                <div>
                    <h4 className="fw-bold mb-1">{config.titulo}</h4>
                    <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>
                        <strong>Detalle:</strong> {ultimoComentario}
                    </p>
                </div>
            </div>
        );
    };

    if (loading) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }}></div>
                <p className="mt-3 fw-semibold">Cargando detalles del trámite ART...</p>
            </div>
        );
    }

    if (!tramite) {
        return <div className="alert alert-danger mt-4">No se encontró el trámite.</div>;
    }

    const cliente = tramite.cliente || {};

    const verDetalleCliente = (cuil) => navigate(`/clientes/vista-detallada/${cuil.toString()}`);

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-start mb-4">
                <div style={{ flex: '1 1 20rem', minWidth: 0 }}>
                    <div className="d-flex align-items-center flex-wrap gap-3 mb-1">
                        <h2 className="fw-bold text-primary mb-0">Detalles del Trámite ART</h2>
                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary-subtle rounded-pill fs-6 px-3">
                            ART
                        </span>
                        <EtiquetaTramite etiqueta={tramite.etiqueta} />
                    </div>
                    {cliente?.apellido && cliente?.nombre && (
                        <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                            <h5 className="text-secondary fw-semibold mb-0">
                                <PersonSearchIcon fontSize="small" className="me-1 mb-1" />
                                {apellidoNombre(cliente.apellido, cliente.nombre)}
                            </h5>
                            {cliente.telefonoPropio && (
                                <WhatsAppHeaderButton
                                    phone={cliente.telefonoPropio}
                                    clientName={`${cliente.nombre} ${cliente.apellido}`}
                                    onClick={() => window.dispatchEvent(
                                        new CustomEvent('openAdminSidebar', { detail: { tab: 'whatsapp' } })
                                    )}
                                />
                            )}
                        </div>
                    )}
                    <PanelUbicacionTramite tramite={tramite} onUpdated={setTramite} />
                </div>
                <div className="d-flex gap-2 mt-1 align-items-center flex-wrap">
                    <BotonGenerarCaratula
                        tipo="ART"
                        idTramite={tramite.idTramite}
                        onGenerado={() => setArchivosVersion((v) => v + 1)}
                    />
                    <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill"
                        onClick={volverAtras}
                    >
                        <ArrowBackIcon fontSize="small" /> Volver
                    </button>
                </div>
            </div>

            {/* Trámite RTI complementario */}
            {tramitesRTICliente.length > 0 ? (
                <Box sx={{
                    mb: 2, p: 2, borderRadius: '12px',
                    border: '1px solid #a5b4fc',
                    background: 'var(--gradient-primary-light)',
                    display: 'flex', alignItems: 'flex-start', gap: 1.5
                }}>
                    <i className="bi bi-info-circle-fill" style={{ color: '#6366f1', fontSize: '1.1rem', marginTop: 2 }}></i>
                    <Box>
                        <Typography sx={{ fontWeight: 700, color: '#3730a3', fontSize: '0.88rem' }}>
                            Este cliente también tiene {tramitesRTICliente.length === 1 ? 'un trámite RTI' : `${tramitesRTICliente.length} trámites RTI`}
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 0.75 }}>
                            {tramitesRTICliente.map((t) => (
                                <Chip
                                    key={t.idTramite}
                                    label={`#${t.idTramite} — ${t.nombreEstadoActual || t.estadoActual || 'Sin estado'}`}
                                    size="small"
                                    clickable
                                    onClick={() => navigate(`/rti/tramites/${t.idTramite}`)}
                                    sx={{ background: '#e0e7ff', color: '#3730a3', fontWeight: 600 }}
                                />
                            ))}
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box sx={{
                    mb: 2, p: 2, borderRadius: '12px',
                    border: '1px solid #d1d5db',
                    background: '#f9fafb',
                    display: 'flex', alignItems: 'flex-start', gap: 1.5
                }}>
                    <i className="bi bi-file-earmark-x" style={{ color: '#9ca3af', fontSize: '1.1rem', marginTop: 2 }}></i>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography sx={{ fontWeight: 700, color: '#374151', fontSize: '0.88rem' }}>
                            Este cliente no tiene trámite RTI
                        </Typography>
                        {tramite?.comentarios && (() => {
                            const match = tramite.comentarios.match(/(?:\[MOTIVO NO INICIO RTI]\s*|Motivo por no iniciar RTI:\s*|Motivo por el cual no se inicia tambi[eé]n RTI:\s*)(.+?)(?:\n|$)/i);
                            return match ? (
                                <Typography sx={{ fontSize: '0.82rem', color: '#6b7280', mt: 0.5 }}>
                                    Motivo registrado: {match[1]}
                                </Typography>
                            ) : null;
                        })()}
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() => navigate(`/rti/tramites/iniciar-tramite/${tramite?.cliente?.cuil}`)}
                            sx={{ mt: 1, borderRadius: '8px', textTransform: 'none', fontSize: '0.8rem', borderColor: '#6366f1', color: '#4f46e5' }}
                        >
                            <i className="bi bi-plus-circle me-1"></i>
                            Iniciar trámite RTI
                        </Button>
                    </Box>
                </Box>
            )}

            {renderEstadoFinalBanner()}

            {/* Nota Sticky de Comentarios */}
            {tramite && (
                <NotaComentario
                    valor={tramite.comentarios || ''}
                    onGuardar={handleGuardarComentario}
                    label="Comentarios del Trámite ART"
                    color="blue"
                    nombreUsuario={user?.nombre || ''}
                />
            )}

            {/* Cobranza del trámite: desplegable, debajo del estado y los comentarios */}
            <SeccionCobranzaTramite tramite={tramite} />

            {/* 🕓 Línea de tiempo de estados */}
            <div
                className="card shadow-sm border-0 rounded-4 p-4 mt-2 mb-3"
                style={{ backgroundColor: "#f8f9fa", cursor: "pointer", transition: "all 0.2s ease" }}
                onClick={handleAbrirHistorial}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e9ecef"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#f8f9fa"; e.currentTarget.style.transform = "translateY(0)"; }}
            >
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold text-secondary mb-0">Progreso del Trámite</h5>
                    <span className="text-primary">
                        <i className="bi bi-arrow-right-circle me-1"></i>Ver detalles
                    </span>
                </div>
                <div className="d-flex justify-content-between align-items-center position-relative" style={{ overflowX: "auto", padding: "10px 0" }}>
                    <div className="position-absolute start-0 border-top" style={{ top: "35%", left: "-3%", width: "170%", borderTop: "3px solid #dee2e6", zIndex: 1 }}></div>
                    {estadosOrden.map((estado, index) => {
                        const indiceActual = estadosOrden.indexOf(tramite.nombreEstadoActual);
                        const completado = index < indiceActual;
                        const actual = index === indiceActual;
                        const fallido = actual && estadosFallidosNombres.includes(tramite.nombreEstadoActual);
                        let color = "#adb5bd";
                        if (completado) color = "#0d6efd";
                        if (actual) color = fallido ? "#dc3545" : "#198754";
                        const borde = actual ? `4px solid ${color}` : `2px solid ${color}`;
                        return (
                            <div key={estado} className="d-flex flex-column align-items-center text-center" style={{ position: "relative", zIndex: 2, minWidth: "160px" }}>
                                <div className="rounded-circle mb-2" style={{ width: "22px", height: "22px", backgroundColor: color, border: borde, transition: "all 0.3s ease" }}></div>
                                <span style={{ fontSize: "0.85rem", color: actual ? color : (completado ? "#0d6efd" : "#6c757d"), fontWeight: actual ? "600" : "normal", whiteSpace: "nowrap" }}>
                                    {estado}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Gestor dinámico de estados específico para ART */}
            {!estadosFallidosNombres.includes(tramite.nombreEstadoActual) && tramite.idEstadoActual !== 8 && (
                <GestorCambioEstadoART
                    tramite={tramite}
                    onEstadoCambiado={async () => {
                        await recargarTramite();
                        await cargarSiniestros();
                    }}
                />
            )}

            {/* LISTADO DE SINIESTROS + SUGERENCIAS INTELIGENTES */}
            <div className="row mb-3 mt-4 g-3 align-items-start">
                {/* Siniestros — columna principal */}
                <div className={tramitesSimilares.length > 0 ? "col-xl-9 col-12" : "col-12"}>
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex align-items-center gap-2">
                                <h4 className="fw-bold text-primary mb-0">Siniestros del Trámite</h4>
                                <span className="badge bg-secondary fs-6">{siniestros.length}</span>
                            </div>
                            <button
                                className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill fw-semibold"
                                onClick={() => setModalFormSiniestroOpen(true)}
                            >
                                <span style={{ fontSize: '1.2rem' }}>+</span> Crear Siniestro
                            </button>
                        </div>
                        <ListarSiniestros
                            key={tramite?.nombreEstadoActual}
                            siniestros={siniestros}
                            loading={cargandoSiniestros}
                            onRefresh={cargarSiniestros}
                            tramiteId={idTramite}
                            tramiteEstadoActual={tramite?.nombreEstadoActual}
                        />
                    </div>
                </div>

                {/* 💡 Sugerencia inteligente — panel lateral compacto */}
                {tramitesSimilares.length > 0 && (
                    <div className="col-xl-3 col-12">
                        <Paper
                            elevation={0}
                            sx={{
                                p: 1.75,
                                borderRadius: '14px',
                                border: '1px solid #fde68a',
                                background: 'var(--gradient-primary-light)',
                                position: 'sticky',
                                top: 16,
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                                <TipsAndUpdatesIcon sx={{ color: '#f59e0b', fontSize: 17 }} />
                                <Typography sx={{ fontWeight: 700, color: '#1e3a8a', fontSize: '0.82rem', lineHeight: 1.2 }}>
                                    Posibles duplicados
                                </Typography>
                            </Box>

                            <Typography sx={{ color: '#64748b', fontSize: '0.72rem', mb: 1.25, lineHeight: 1.4 }}>
                                Se encontraron trámites similares a este.
                            </Typography>

                            <Box sx={{ display: 'grid', gap: 0.85 }}>
                                {tramitesSimilares.map((similar) => (
                                    <Box
                                        key={similar.idTramite}
                                        sx={{
                                            p: 1.1,
                                            borderRadius: '10px',
                                            bgcolor: 'rgba(255,255,255,0.82)',
                                            border: '1px solid #e2e8f0'
                                        }}
                                    >
                                        <Typography sx={{ fontWeight: 700, color: '#0f172a', fontSize: '0.75rem', lineHeight: 1.3 }}>
                                            #{similar.idTramite} — {similar.nombreCliente || 'Cliente sin nombre'}
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.6 }}>
                                            <Chip
                                                label={`${similar.porcentajeSimilitud || 0}% coincidencia`}
                                                size="small"
                                                sx={{
                                                    height: 18,
                                                    fontSize: '0.65rem',
                                                    fontWeight: 700,
                                                    bgcolor: '#dbeafe',
                                                    color: '#1e40af'
                                                }}
                                            />
                                        </Box>
                                        {Array.isArray(similar.motivosCoincidencia) && similar.motivosCoincidencia.length > 0 && (
                                            <Typography sx={{ mt: 0.6, color: '#64748b', fontSize: '0.68rem', lineHeight: 1.35 }}>
                                                {similar.motivosCoincidencia.join(' · ')}
                                            </Typography>
                                        )}
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            onClick={() => handleVerTramiteSimilar(similar.idTramite)}
                                            sx={{
                                                mt: 0.85,
                                                py: 0.35,
                                                borderRadius: '20px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.68rem',
                                                borderColor: '#3B82F6',
                                                color: '#2563eb',
                                                '&:hover': {
                                                    borderColor: '#1e40af',
                                                    bgcolor: '#eff6ff'
                                                }
                                            }}
                                        >
                                            Ver trámite
                                        </Button>
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    </div>
                )}
            </div>

            {/* 📅 Apartado de Eventos */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="fw-bold text-primary mb-0">Eventos del Trámite</h4>
                            <button
                                className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill fw-semibold"
                                onClick={() => {
                                    const hoy = new Date();
                                    setFechaSeleccionadaEvento(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
                                    setMostrarModalEvento(true);
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>+</span> Crear Evento
                            </button>
                        </div>
                        {cargandoEventos ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status"></div>
                                <p className="mt-2 text-muted">Cargando eventos...</p>
                            </div>
                        ) : eventos.length === 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center">
                                <p className="mb-0">No hay eventos registrados para este trámite</p>
                            </div>
                        ) : (
                            <div className="row g-3">
                                {eventos.map(evento => (
                                    <div key={evento.idEvento} className="col-md-6 col-lg-4">
                                        <div className="card h-100 border rounded-3 p-3 shadow-sm hover-shadow">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h6 className="fw-bold text-primary mb-0">{evento.titulo}</h6>
                                                {evento.tipoEvento && <span className="badge bg-primary rounded-pill">{evento.tipoEvento}</span>}
                                            </div>
                                            {evento.descripcion && <p className="text-muted small mb-2">{evento.descripcion}</p>}
                                            <div className="mt-auto">
                                                <div className="d-flex align-items-center gap-2 mb-1">
                                                    <small className="text-muted">📅</small>
                                                    <small className="fw-semibold">{formatearFechaEvento(evento.fecha)}</small>
                                                </div>
                                                {evento.todoElDia ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small className="text-success fw-semibold">Todo el día</small>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small>{evento.horaInicio} - {evento.horaFin}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Contenedor con dos columnas: Info del Trámite ART + Info del Cliente */}
            <div className="row g-4">
                {/* 🟦 Datos del trámite ART */}
                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold text-primary mb-3">
                            <i className="bi bi-heart-pulse me-2"></i>
                            Información del Trámite ART
                        </h4>

                        {editMode ? (
                            <>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Fecha de baja exacta</label>
                                    <input
                                        type="date"
                                        className="form-control rounded-3 shadow-sm"
                                        value={tramiteEdit.fechaBaja ? tramiteEdit.fechaBaja.split('T')[0] : ''}
                                        onChange={(e) => setTramiteEdit({ ...tramiteEdit, fechaBaja: e.target.value || null })}
                                    />
                                    <div className="form-text">Día exacto de baja laboral. Permite calcular el vencimiento con precisión de días.</div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Fecha de inicio del trámite</label>
                                    <input
                                        type="date"
                                        className="form-control rounded-3 shadow-sm"
                                        value={tramiteEdit.fechaInicio ? tramiteEdit.fechaInicio.split('T')[0] : ''}
                                        onChange={(e) => setTramiteEdit({ ...tramiteEdit, fechaInicio: e.target.value || null })}
                                    />
                                    <div className="form-text">Si el trámite fue iniciado antes de cargarlo al sistema, ingresá la fecha real. Determina el mes de agrupación en el listado.</div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Organismo</label>
                                    <select
                                        className="form-select rounded-3 shadow-sm"
                                        value={tramiteEdit.organismo || ''}
                                        onChange={(e) => setTramiteEdit({ ...tramiteEdit, organismo: e.target.value || '' })}
                                    >
                                        <option value="">Sin especificar</option>
                                        <option value="PROVINCIA">Provincia</option>
                                        <option value="ANSES">ANSES</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Clasificación</label>
                                    <select
                                        className="form-select rounded-3 shadow-sm"
                                        value={tramiteEdit.clasificacion || ''}
                                        onChange={(e) => setTramiteEdit({ ...tramiteEdit, clasificacion: e.target.value || '' })}
                                    >
                                        <option value="">Sin clasificar</option>
                                        <option value="ACCIDENTE_LABORAL">Accidente Laboral</option>
                                        <option value="ENFERMEDAD_LABORAL">Enfermedad Laboral</option>
                                        <option value="AMBAS">Ambas</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Aseguradora</label>
                                    <select
                                        className="form-select rounded-3 shadow-sm"
                                        value={tramiteEdit.idAseguradora || ''}
                                        onChange={(e) => setTramiteEdit({ ...tramiteEdit, idAseguradora: e.target.value ? Number(e.target.value) : '' })}
                                    >
                                        <option value="">Sin asignar</option>
                                        {aseguradoras.map((aseg) => (
                                            <option key={aseg.idAseguradora || aseg.id} value={aseg.idAseguradora || aseg.id}>
                                                {aseg.nombre || aseg.razonSocial || `Aseguradora ${aseg.idAseguradora || aseg.id}`}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <button className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" onClick={handleGuardar}>
                                        Guardar Cambios
                                    </button>
                                    <button className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" onClick={handleCancelar}>
                                        Cancelar
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p><strong>ID Trámite:</strong> {tramite.idTramite}</p>
                                <p><strong>Tipo de Trámite:</strong> {tramite.tipoTramite?.nombre || "ART"}</p>
                                <p><strong>Estado Actual:</strong> {tramite.nombreEstadoActual || "N/A"}</p>
                                <p><strong>Fecha Estado Actual:</strong> {tramite.fechaEstadoActual ? new Date(tramite.fechaEstadoActual).toLocaleString() : "N/A"}</p>

                                {(() => {
                                    const semaforo = obtenerSemaforoArt();
                                    const art = evaluacionArt?.art;
                                    return (
                                        <div className="card border-2 rounded-4 p-3 mb-3" style={{ borderColor: semaforo.borde, background: '#fff' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <strong style={{ color: '#6c757d' }}>Regularidad ART</strong>
                                                <span
                                                    className={semaforo.badgeClass !== 'badge-tramite-iniciado' ? `badge rounded-pill px-3 py-2 ${semaforo.badgeClass}` : 'badge rounded-pill px-3 py-2'}
                                                    style={semaforo.badgeClass === 'badge-tramite-iniciado' ? { backgroundColor: '#0891b2', color: '#fff' } : {}}
                                                >{semaforo.badge}</span>
                                            </div>
                                            <p className="mb-2" style={{ color: '#374151' }}>{semaforo.estado}</p>
                                            {art?.mensaje && <p className="mb-2" style={{ color: '#4b5563' }}>{art.mensaje}</p>}
                                            <div className="small" style={{ color: '#374151' }}>
                                                {(() => {
                                                    const estadoNombre = (tramite?.nombreEstadoActual || '').toLowerCase().trim();
                                                    const postTelegrama = ESTADOS_POST_TELEGRAMA_DETALLE.has(estadoNombre);
                                                    if (postTelegrama) {
                                                        return <div><strong>Estado del plazo:</strong> El trámite fue iniciado formalmente. El plazo de 2 años ya no aplica.</div>;
                                                    }
                                                    if (tramite?.fechaVencimiento && typeof tramite.fechaVencimiento === 'string') {
                                                        const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
                                                        const venc = new Date(tramite.fechaVencimiento); venc.setHours(0, 0, 0, 0);
                                                        if (isNaN(venc.getTime())) {
                                                            return <div><strong>Plazo restante para iniciar:</strong> {formatearDuracionMeses(evaluacionArt?.plazoRestanteMeses || 0)}</div>;
                                                        }
                                                        const dias = Math.round((venc - hoy) / (1000 * 60 * 60 * 24));
                                                        const fechaStr = venc.toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });
                                                        return (
                                                            <>
                                                                <div><strong>Fecha de baja registrada:</strong> {new Date(tramite.fechaBaja).toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'UTC' })}</div>
                                                                <div><strong>Vencimiento exacto (2 años):</strong> {fechaStr}</div>
                                                                <div><strong>Tiempo restante:</strong> {dias < 0 ? `Venció hace ${Math.abs(dias)} día${Math.abs(dias) !== 1 ? 's' : ''}` : dias === 0 ? 'Vence hoy' : `${dias} día${dias !== 1 ? 's' : ''}`}</div>
                                                            </>
                                                        );
                                                    }
                                                    return <div><strong>Plazo restante para iniciar:</strong> {formatearDuracionMeses(evaluacionArt?.plazoRestanteMeses || 0)}</div>;
                                                })()}
                                                {art?.periodoUltimaRelacionDesde && art?.periodoUltimaRelacionHasta && (
                                                    <>
                                                        <div><strong>Última relación laboral:</strong> {art.periodoUltimaRelacionDesde} a {art.periodoUltimaRelacionHasta}</div>
                                                        <div><strong>Empleador:</strong> {art.ultimoEmpleador || 'No informado'} · <strong>CUIT:</strong> {art.ultimoCuitEmpleador || 'No informado'}</div>
                                                        <div><strong>Antigüedad en ese trabajo:</strong> {formatearDuracionMeses(art.antiguedadMeses || 0)}</div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })()}

                                <Box sx={{ mt: 3, mb: 3 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                                        <i className="bi bi-clipboard-data me-2"></i>Datos Específicos ART
                                    </Typography>
                                    <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.5 }}>
                                                Organismo
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                                {tramite.organismo === 'PROVINCIA' ? 'Provincia'
                                                    : tramite.organismo === 'ANSES' ? 'ANSES'
                                                    : 'Sin especificar'}
                                            </Typography>
                                        </Paper>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.5 }}>
                                                Aseguradora
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                                {tramite.nombreAseguradora || tramite.artReclamo?.nombre || 'No asignada'}
                                            </Typography>
                                        </Paper>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.5 }}>
                                                Clasificación
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                                {tramite.clasificacion === 'ACCIDENTE_LABORAL' ? 'Accidente Laboral'
                                                    : tramite.clasificacion === 'ENFERMEDAD_LABORAL' ? 'Enfermedad Laboral'
                                                    : tramite.clasificacion === 'AMBAS' ? 'Ambas'
                                                    : 'Sin clasificar'}
                                            </Typography>
                                        </Paper>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.5 }}>
                                                Fecha de baja exacta
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                                {tramite.fechaBaja
                                                    ? new Date(tramite.fechaBaja).toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'UTC' })
                                                    : 'No registrada'}
                                            </Typography>
                                        </Paper>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.5 }}>
                                                Fecha de inicio del trámite
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                                                {tramite.fechaInicio
                                                    ? new Date(tramite.fechaInicio).toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'UTC' })
                                                    : 'No registrada (se usa la fecha de carga)'}
                                            </Typography>
                                        </Paper>
                                    </Box>
                                </Box>

                                {/* Comentarios de cancelación/reactivación */}
                                {tramite.ultimoComentario && (
                                    <div className="mt-3">
                                        <strong>
                                            {tramite.idEstadoActual === 14 ? (
                                                <span className="text-secondary"><CancelIcon fontSize="small" className="me-1" />Motivo de Cancelación:</span>
                                            ) : (
                                                <span className="text-secondary"><PersonSearchIcon fontSize="small" className="me-1" />Último Comentario de Estado:</span>
                                            )}
                                        </strong>
                                        <div className="border rounded-3 p-3 mt-1" style={{ backgroundColor: '#f3f4f6', borderColor: '#e5e7eb' }}>
                                            <div style={{ whiteSpace: 'pre-line', fontSize: '0.95rem' }}>{tramite.ultimoComentario}</div>
                                        </div>
                                    </div>
                                )}

                                {/* Checklist: Fotocopia DNI / Pacto OK / Carátula */}
                                <ChecklistTramite tramite={tramite} onActualizado={recargarTramite} />
                                <TarjetaCobroTramite
                                    tramite={tramite}
                                    onPactoGenerado={() => { setArchivosVersion((v) => v + 1); recargarTramite(); }}
                                />

                                <div className="mt-4 d-flex justify-content-center gap-3 flex-wrap">
                                    {!estadosFallidosNombres.includes(tramite.nombreEstadoActual) && tramite.idEstadoActual !== 8 && (
                                        <button className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" style={{ fontSize: "1rem" }} onClick={handleModificar}>
                                            Editar datos
                                        </button>
                                    )}
                                    {puedeCancelar() && (
                                        <button className="btn btn-outline-danger d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" style={{ fontSize: "1rem" }} onClick={() => setMostrarDialogoCancelar(true)}>
                                            <CancelIcon fontSize="small" /> Cancelar Trámite
                                        </button>
                                    )}
                                    {puedeReactivar() && (
                                        <button className="btn btn-outline-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" style={{ fontSize: "1rem" }} onClick={() => setMostrarDialogoReactivar(true)}>
                                            <PersonSearchIcon fontSize="small" /> Reactivar Trámite
                                        </button>
                                    )}
                                    <button className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" style={{ fontSize: "1rem" }} onClick={handleAbrirGastos}>
                                        <i className="bi bi-cash-coin"></i> Ver Gastos
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* 🟩 Datos del cliente */}
                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold mb-3" style={{ color: "#6c757d" }}>Información del Cliente</h4>
                        <div>
                            <p><strong>CUIL:</strong> {cliente.cuil || "N/A"}</p>
                            <p><strong>Nombre:</strong> {cliente.nombre || "N/A"}</p>
                            <p><strong>Apellido:</strong> {cliente.apellido || "N/A"}</p>
                            <p><strong>Oficio / Actividad:</strong> {cliente.oficio || cliente.actividad || "N/A"}</p>
                            <p><strong>Teléfono:</strong> {normalizeTelefonoForStorage(cliente.telefonoPropio) || "N/A"}</p>
                        </div>
                        {cliente.cuil && (
                            <div className="mt-4 d-flex justify-content-center gap-2">
                                <button className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" style={{ fontSize: "1rem" }} onClick={() => verDetalleCliente(cliente.cuil)}>
                                    <PersonSearchIcon fontSize="medium" /> Ver Detalle del Cliente
                                </button>
                            </div>
                        )}

                        <hr className="my-3" />
                        <div className="mt-2">
                            <h6 className="fw-bold text-secondary mb-2">🩺 Historial Médico</h6>
                            {preexistenciasCliente.length > 0 ? (
                                <>
                                    <div className="d-flex flex-column gap-2">
                                        {preexistenciasCliente.map((p) => (
                                            <div key={p.idPreexistencia} className="border rounded-3 bg-light p-2">
                                                <div className="small text-muted">
                                                    Fecha: {p.fechaReclamo || 'N/A'}
                                                    {p.porcentaje !== null && p.porcentaje !== undefined && (
                                                        <span className="badge bg-secondary ms-2">
                                                            {p.porcentaje}%
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="fw-semibold">{p.descripcion || 'Sin descripción'}</div>
                                            </div>
                                        ))}
                                    </div>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, width: '100%' }}>
                                        <Button
                                            variant="outlined"
                                            sx={{ borderRadius: '20px' }}
                                            onClick={() => setModalPreexistenciasOpen(true)}
                                        >
                                            Ver más / Gestionar
                                        </Button>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <div className="text-muted fst-italic">
                                        No hay ninguna preexistencia cargada con este cliente.
                                    </div>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, width: '100%' }}>
                                        <Button
                                            variant="contained"
                                            sx={{ borderRadius: '20px' }}
                                            onClick={() => setModalPreexistenciasOpen(true)}
                                        >
                                            Agregar preexistencia
                                        </Button>
                                    </Box>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Gestión de Archivos */}
            <div className="row g-4 mt-2">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <div className="p-3 bg-light rounded-3">
                            <CargaArchivos key={archivosVersion} idTramite={idTramite} onArchivosActualizados={recargarTramite} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal para crear evento */}
            <CrearEventoModal
                isOpen={mostrarModalEvento}
                onClose={() => setMostrarModalEvento(false)}
                onSave={handleGuardarEvento}
                selectedDate={fechaSeleccionadaEvento}
                idTramite={idTramite}
            />

            {/* Modal de confirmación de cancelación */}
            {mostrarDialogoCancelar && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div className="modal-header border-0 pb-2">
                                <h5 className="modal-title fw-bold text-warning"><CancelIcon className="me-2" />Cancelar Trámite ART</h5>
                                <button type="button" className="btn-close" onClick={() => { setMostrarDialogoCancelar(false); setMotivoCancelacion(''); setObservacionesCancelacion(''); }}></button>
                            </div>
                            <div className="modal-body px-4">
                                <div className="alert alert-warning d-flex align-items-center mb-3">
                                    <CancelIcon className="me-2" />
                                    <div>
                                        <strong>¿Está seguro de cancelar este trámite?</strong><br />
                                        <small>El trámite pasará al estado "Cancelado". Esta acción se registrará en el historial.</small>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Motivo de cancelación <span className="text-danger">*</span>:</label>
                                    <select className="form-select shadow-sm" value={motivoCancelacion} onChange={(e) => setMotivoCancelacion(e.target.value)} required>
                                        <option value="">Seleccione un motivo...</option>
                                        <option value="Solicitud del cliente">Solicitud del cliente</option>
                                        <option value="Documentación incompleta">Documentación incompleta</option>
                                        <option value="Cambio de circunstancias">Cambio de circunstancias</option>
                                        <option value="Error en la gestión">Error en la gestión</option>
                                        <option value="Desistimiento voluntario">Desistimiento voluntario</option>
                                        <option value="Otros">Otros</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Observaciones (opcional):</label>
                                    <textarea className="form-control shadow-sm" rows="3" placeholder="Detalles adicionales..." value={observacionesCancelacion} onChange={(e) => setObservacionesCancelacion(e.target.value)} />
                                </div>
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={() => { setMostrarDialogoCancelar(false); setMotivoCancelacion(''); setObservacionesCancelacion(''); }}>Volver</button>
                                <button type="button" className="btn btn-warning rounded-pill px-4 fw-semibold" onClick={handleCancelarTramite} disabled={!motivoCancelacion.trim()}>
                                    <CancelIcon fontSize="small" className="me-1" /> Cancelar Trámite
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Reactivación */}
            {mostrarDialogoReactivar && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content rounded-4 shadow-lg border-0">
                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fw-bold text-success"><PersonSearchIcon className="me-2" />Reactivar Trámite ART</h5>
                                <button type="button" className="btn-close" onClick={() => { setMostrarDialogoReactivar(false); setObservacionesReactivacion(''); }}></button>
                            </div>
                            <div className="modal-body py-4">
                                <div className="alert alert-info border-0 rounded-3">
                                    <strong>📋 Información:</strong>
                                    <p className="mb-0 mt-2">El trámite será reactivado y volverá al estado anterior a la cancelación.<br/>Esta acción se registrará en el historial.</p>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="observacionesReactivacion" className="form-label fw-semibold text-muted">Observaciones (obligatorio):</label>
                                    <textarea id="observacionesReactivacion" className="form-control rounded-3 border-2" placeholder="Explique el motivo de la reactivación..." value={observacionesReactivacion} onChange={(e) => setObservacionesReactivacion(e.target.value)} rows="4" style={{ resize: 'vertical', minHeight: '100px' }} />
                                    <div className="form-text">Mínimo 5 caracteres requeridos</div>
                                </div>
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={() => { setMostrarDialogoReactivar(false); setObservacionesReactivacion(''); }}>Volver</button>
                                <button type="button" className="btn btn-success rounded-pill px-4 fw-semibold" onClick={handleReactivarTramite} disabled={!observacionesReactivacion.trim() || observacionesReactivacion.trim().length < 5}>
                                    <PersonSearchIcon fontSize="small" className="me-1" /> Reactivar Trámite
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Acciones irreversibles (cambiar tipo / eliminar definitivamente).
                El propio panel decide si mostrarse segun el rol. */}
            <PanelAccionesAvanzadasTramite
                idTramite={tramite?.idTramite}
                tipoTramite="ART"
            />

            {/* Modal de Historial de Estados — filtrado por ámbito ART */}
            <HistorialTramite
                isOpen={modalHistorialAbierto}
                onClose={() => setModalHistorialAbierto(false)}
                idTramite={idTramite}
                onEstadoCambiado={recargarTramite}
                ambitoFiltro="ART"
            />

            {/* Modal de Gastos por Trámite */}
            <ModalGastosPorTramite
                open={modalGastosOpen}
                onClose={handleCerrarGastos}
                idTramite={idTramite}
            />

            {/* Modal para crear/editar siniestro */}
            <ModalFormularioSiniestro
                isOpen={modalFormSiniestroOpen}
                onClose={() => { setModalFormSiniestroOpen(false); setSiniestroAEditar(null); }}
                idTramite={Number(idTramite)}
                siniestroAEditar={siniestroAEditar}
                onSave={() => {
                    cargarSiniestros();
                    toast.success(siniestroAEditar ? 'Siniestro actualizado' : 'Siniestro registrado');
                }}
            />

            {/* Modal para ver detalle de siniestro */}
            <ModalDetalleSiniestro
                isOpen={modalDetalleSiniestroOpen}
                onClose={() => { setModalDetalleSiniestroOpen(false); setSiniestroSeleccionado(null); }}
                siniestro={siniestroSeleccionado}
                onEdit={(s) => {
                    setModalDetalleSiniestroOpen(false);
                    setSiniestroAEditar(s);
                    setModalFormSiniestroOpen(true);
                }}
                onDelete={() => {
                    cargarSiniestros();
                    toast.success('Siniestro eliminado correctamente');
                }}
            />

            <ModalPreexistencias
                isOpen={modalPreexistenciasOpen}
                onClose={() => setModalPreexistenciasOpen(false)}
                clienteCuil={cliente.cuil}
                preexistencias={preexistenciasCliente}
                onPreexistenciaModificada={cargarPreexistenciasCliente}
            />

            <CustomModal {...modalState} onHide={hideModal} />
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            <WhatsAppChatModal
                isOpen={whatsAppTarget !== null}
                onClose={() => setWhatsAppTarget(null)}
                clientName={whatsAppTarget?.name || 'Cliente'}
                phone={whatsAppTarget?.phone || ''}
            />

            {/* Botón flotante de feedback */}
            <FeedbackButton tramite={tramite} />
        </div>
    );
}

export default VistaDetalladaTramiteART;